import { BAOCustomElement } from '@bao/custom-element'
import { Cart } from '@bao/cart'

class RecentlyViewed extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.dataset.recentlyViewed) return

    this.setRecentlyViewed()
  }

  async setRecentlyViewed () {
    await Cart.updateCartAttributes({
      recently_viewed_products: `${this.dataset.recentlyViewed}`,
    })
  }
}

if (!customElements.get('recently-viewed')) {
  customElements.define('recently-viewed', RecentlyViewed)
}
